import { planningAPI } from "../../axios";

export const actions = {

    //ExtensionActivityFileSetting
    GetAllExtensionActivityFile(context, data){
        return planningAPI.get(`ExtensionActivityFileSetting/All`);
    },
    GetSingleExtensionActivityFile(context, data){
        return planningAPI.get(`ExtensionActivityFileSetting/${data}`);
    },
    UpdateExtensionActivityFile(context, data){
        return planningAPI.put(`ExtensionActivityFileSetting/${data.id}`, data);
    },
    DeleteExtensionActivityFile(context, data){
        return planningAPI.delete(`ExtensionActivityFileSetting/${data}`);
    },
    CreateExtensionActivityFile(context, data){
        return planningAPI.post(`ExtensionActivityFileSetting`, data);
    },

}